module.exports = __webpack_public_path__ + "assets/img/ynthree.b55e17a4.png";